<template>
  <v-container>
    <v-card flat>
      <v-container>
        <h2 class="text-lg-center text-md-center text-sm-center earth-color">THANK YOU FOR YOUR SUPPORT.</h2>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'success-donation',
  data () {
    return {}
  }
}
</script>

<style scoped>

</style>
